import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { SignUpForm } from '../../../components/forms';
import { signUpInit } from '../../../store/actions/auth';
import {
  makeSelectUser,
  makeSelectAuthProceeding,
} from '../../../store/selectors';

const SignUp = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const user = useSelector(makeSelectUser());
  const isProceeding = useSelector(makeSelectAuthProceeding());

  useEffect(() => {
    if (user) {
      localStorage.setItem('visited', 'true');
      history.push('/');
      // if (user.verified) {
      // } else {
      //   history.push('/verify-email');
      // }
    }
  }, [user]);

  const handleSubmit = (data) => {
    dispatch(signUpInit(data));
  };

  return (
    <div className="w-1/3 m-auto p-6 rounded-2xl bg-white shadow-lg">
      <SignUpForm busy={isProceeding} onSubmit={handleSubmit} />
    </div>
  );
};

export default SignUp;
